import React from "react";
import { Modal, Spin } from "antd";
import "./PaymentProcessing.css";

export default function PaymentProcessing({ visible }) {
  return (
    <Modal
      className="payment-processing-modal"
      visible={visible}
      footer={null}
      closable={false}
      maskClosable={false}
      keyboard={false}
      centered
      width={440}
    >
      <div className="payment-processing-content">
        <Spin size="large" />

        <h2>Processing your order</h2>

        <p>
          Your payment was confirmed. We&apos;re creating your order and
          completing the transaction.
        </p>

        <span>Please keep this page open. This may take a few seconds.</span>
      </div>
    </Modal>
  );
}
